import React, { Component } from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import omit from 'lodash/omit';

import { withBasicTextarea } from 'zoomforth_component_lib/basic_textarea.jsx';

class ZFTextareaAutosize extends Component {

  componentDidMount() {
    if (this.props.focusOnMount) {
      this.textareaRef.focus();
    }
  }

  render() {
    const props = omit(this.props, 'focusOnMount');

    return (
      <TextareaAutosize
        maxRows={5}
        style={{ resize:'none' }}
        innerRef={(textareaRef) => {
          this.textareaRef = textareaRef;
        }}
        {...props}
      />
    );
  }

}

export default withBasicTextarea(ZFTextareaAutosize);
